<template>
  <div :class="['cart-list', theme ? `cart-list--${theme}` : false]">
    <div
      v-for="(cartItem, index) in cart.items"
      :key="index"
      :data-key="cartItem.key"
      :data-quantity="cartItem.quantity"
      class="cart-list__item"
    >
      <div class="separator--row" />
      <Figure
        v-if="theme !== 'checkout'"
        class="cart-list__item__image"
        :data="{
          default: { sizes: { l: cartItem.product_image } },
          ratio: 3 / 4,
          object_fit: 'cover',
        }"
      />
      <router-link
        :to="{
          name: 'SingleProduct',
          params: {
            slug: cartItem.slug,
          },
        }"
        class="cart-list__item__name typo--m"
      >
        {{ cartItem.product_name }}
      </router-link>
      <div
        v-if="cartItem.is_deposit"
        class="typo--m cart-list__item__price"
        v-html="cartItem.deposit_item_subtotal"
      />
      <div
        v-else
        class="typo--m cart-list__item__price"
        v-html="getLineTotal(cartItem)"
      />
      <Number
        v-if="theme !== 'checkout'"
        :key="cartLoading"
        :data="{
          id: `number`,
          fn: numberChanged,
          itemKey: cartItem.key,
          readonly: cartLoading,
        }"
        :value="cartItem.quantity"
      />
      <Icon
        v-if="theme !== 'checkout'"
        name="close"
        theme="invert"
        size="s"
        :fn="() => removeCartItem(cartItem)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { parseCurrency, unparseCurrency } from '@/assets/js/utils-wc';

import Number from '@/components/form/fields/number';
import Figure from '@/components/media/figure';
import Icon from '@/components/ui/icon';

export default {
  name: 'CartList',
  components: {
    Number,
    Figure,
    Icon,
  },
  props: {
    theme: {
      type: String,
      default: 'complete',
    },
  },
  data() {
    return {
      products: [],
    };
  },
  computed: {
    ...mapGetters(['cart', 'cartLoading', 'showCart', 'wcSettings']),
    taxDisplayCart() {
      return this.$store.state.wp.wcSettings.woocommerce_tax_display_cart;
    },
    subtotal() {
      return this.parseCurrency(
        this.unparseCurrency(this.cart.totals.subtotal)
            + this.unparseCurrency(this.cart.totals.subtotal_tax),
      );
    },
  },
  watch: {},
  async mounted() {
    // const request = {
    //   type: 'product',
    //   params: {
    //     // include: [this.cart.items.map((x) => x.product_id)],
    //     per_page: 100,
    //     offset: 0,
    //     lang: this.$store.state.lang,
    //   },
    // };
    // this.products = await this.$store.dispatch('getItems', request);
  },
  methods: {
    updateCartItem(key, quantity) {
      const item = this.cart.items.find((cartItem) => cartItem.key === key);
      const prevQuantity = this.$el.querySelector(`[data-key="${key}"]`)
        ? this.$el.querySelector(`[data-key="${key}"]`).dataset.quantity
        : 0;
      this.$store.dispatch(
        'updateCartItem',
        Object.assign(item, {
          quantity,
          quantityDelta: quantity - prevQuantity,
        }),
      );
    },
    numberChanged(val) {
      if (val[0]) {
        this.updateCartItem(val[0], val[1]);
      } else {
        // $event
        const { target } = val;
        this.updateCartItem(target.dataset.key, target.value);
      }
    },
    removeCartItem(item) {
      const { key } = item;
      const prevQuantity = this.$el.querySelector(`[data-key="${key}"]`)
        ? this.$el.querySelector(`[data-key="${key}"]`).dataset.quantity
        : 0;
      this.$store.dispatch(
        'removeCartItem',
        Object.assign(item, { quantityDelta: prevQuantity }),
      );
    },
    getLineTotal(cartItem) {
      if (this.taxDisplayCart === 'excl') {
        return this.parseCurrency(cartItem.line_subtotal);
      }
      return this.parseCurrency(
        cartItem.line_subtotal + cartItem.line_subtotal_tax,
      );
    },
    parseCurrency(price) {
      return parseCurrency(price, this.wcSettings);
    },
    unparseCurrency(price) {
      return unparseCurrency(price, this.wcSettings);
    },
    // getProductProp(id, element) {
    //   const product = this.products.find((p) => p.id === id);
    //   if (product) {
    //     if (element === 'image' && product.gds_featured_image) {
    //       return product.gds_featured_image.sizes.woocommerce_thumbnail;
    //     }
    //     return product[element];
    //   }
    //   return null;
    // },
  },
};
</script>

<style lang="scss">
  .cart-list {
    display: grid;
    gap: var(--row-gap-m);

    &__item {
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      gap: var(--row-gap-m);

      @include mq(s) {
        grid-template-columns: repeat(6, minmax(0, 1fr));
      }

      .separator--row {
        grid-column: 1 / -1;
      }

      &__image {
        grid-column: 1 / -1;
        grid-row: span 2;

        @include mq(s) {
          grid-column: span 2;
          grid-row: span 2;
        }

        @include mq(m) {
          grid-column: span 1;
          grid-row: span 1;
        }
      }

      &__name {
        @include mq(s) {
          grid-column: span 4;
        }
        @include mq(m) {
          grid-column: span 2;
        }
      }

      .counter {
        width: max-content;

        @include mq(s) {
          grid-column: span 2;
        }

        @include mq(m) {
          grid-column: span 1;
        }
      }

      .icon-close {
        grid-column-end: -1;

        @include mq(s) {
          justify-self: end;
        }
      }
    }

    &--checkout {
      .cart-list {
        &__item {
          grid-template-columns: auto auto 1fr;
          align-items: center;

          &__name {
            grid-row: 2;
            grid-column: 1 / 2;
          }

          &__price,
          .counter,
          .icon-close {
            grid-row: 2;
            grid-column: span 2;
            text-align: right;
          }

          .icon-close {
            justify-self: initial;
          }
        }
      }
    }
  }
</style>
